module.exports = __webpack_public_path__ + "feed8df4442aeffd46095b4b4281587e.svg";